(function () {
  function initOne(controlsEl) {
    const targetRef = controlsEl.getAttribute('data-carousel-target');
    if (!targetRef) return;

    const sectionEl = controlsEl.closest('.section-resource-list') || document;

    // Trova il carousel giusto (desktop o mobile) tramite ref
    const carouselEl = sectionEl.querySelector(`.resource-list__carousel[data-carousel-ref="${targetRef}"]`);
    if (!carouselEl) return;

    // I bottoni nativi REALI del tema
    const nativePrev = carouselEl.querySelector('slideshow-arrows .slideshow-control--previous');
    const nativeNext = carouselEl.querySelector('slideshow-arrows .slideshow-control--next');

    const prevBtn = controlsEl.querySelector('[data-carousel-prev]');
    const nextBtn = controlsEl.querySelector('[data-carousel-next]');
    if (!prevBtn || !nextBtn) return;

    // Se non troviamo i nativi, non agganciamo
    if (!nativePrev || !nativeNext) return;

    prevBtn.addEventListener('click', () => nativePrev.click());
    nextBtn.addEventListener('click', () => nativeNext.click());
  }

  function initAll() {
    document.querySelectorAll('[data-carousel-controls]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor reload sections
  document.addEventListener('shopify:section:load', initAll);
})();
